/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkSelection } from './bulkSelection';

/**
 * Connection-scoped bulk reject, narrowed to a SINGLE job.
 *
 * ``job_id`` is always required: the route authorizes edit access and gates on
 * the job's active ATS link before mutating. Selection is an XOR of an explicit
 * ``job_candidate_ids`` list or a compact pipeline ``bulk`` descriptor (which
 * the backend resolves, capped at 1000).
 */
export interface BulkRejectRequest {
  job_id: string;
  job_candidate_ids?: string[] | null;
  bulk?: BulkSelection | null;
  stage_id?: string | null;
  search?: string | null;
  rejection_reason_id?: string | null;
  note?: string | null;
}
